import React, { useEffect, useState, useMemo, useLayoutEffect } from "react";
// import ReactMapGL, { Marker, Popup, Layer, Source } from "react-map-gl";
import ReactMapGL, { Layer, Source } from "react-map-gl";
import clsx from "clsx";
import useInterval from "@rooks/use-interval";
// import axios from "axios";
import axios from "../../../api/axios";
import mapboxgl from "../../../utils/mapBox";

function mergeCount(data) {
  let map = new Map();
  map.set(data[0]["deviceId"], data[0]["objectsCount"]);
  for (let i = 1; i < data.length; i++) {
    const element = data[i];
    if (map.has(element.deviceId)) {
      let key = element.deviceId;
      let temp = map.get(key);
      temp = temp + element.objectsCount;
      map.set(key, temp);
    } else {
      let key = element.deviceId;
      let value = element.objectsCount;
      map.set(key, value);
    }
  }
  return map;
}

function getMaxCount(map) {
  let arr = [];
  map.forEach((key, value) => {
    arr.push(key);
  });

  arr = arr.sort((a, b) => a - b);
  let index = arr.length - 1;
  return arr[index];
}
function getDensity(deviceCount, maxCount) {
  return deviceCount / maxCount;
}

const StatisticMap = ({ areas, token, mapConfig }) => {
  // console.log(mapConfig);
  const [viewport, setViewport] = useState({
    zoom: window.innerWidth < 1536 ? areas[3].zoom[0] : areas[3].zoom[1],
    bearing: 0,
    pitch: 0,
  });
  const [maxCount, setMaxCount] = useState(0);
  const settings = {
    dragPan: false,
    dragRotate: false,
    scrollZoom: false,
    touchZoom: false,
    touchRotate: false,
    keyboard: false,
    doubleClickZoom: false,
  };
  const latitude = areas[3].center.lat;
  const longitude = areas[3].center.lon;
  const [devices, setDevices] = useState([]);
  const [heatMapCount, setHeatMapCount] = useState(new Map());
  const [loading, setLoading] = useState(true);

  const MAPBOX_TOKEN = mapConfig.mapboxToken; // Set your mapbox token here
  const MAP_STYLE = mapConfig.style;

  function getHeatMapCount() {
    axios
      .get(
        `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }`
        // {
        //   withCredentials: true,
        // }
      )
      .then((res) => {
        let resData = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (res.data[i][j]["hour"].split(":")[0] < new Date().getHours()) {
              resData.push({
                deviceId: res.data[i][j]["deviceId"],
                objectsCount:
                  res.data[i][j]["peopleCount"] +
                  res.data[i][j]["micromobilityCount"] +
                  res.data[i][j]["vehiclesCount"],
              });
            }
          }
        }
        resData = mergeCount(resData);
        let maxCount = getMaxCount(resData);
        setMaxCount((prev) => maxCount);
        setHeatMapCount((prev) => resData);
        setLoading((prev) => false);
      })
      .catch((err) => console.log(err));
  }
  function getDevices() {
    let devices = [];
    areas[3].devices.forEach((device) => {
      devices.push(device.deviceId);
    });
    setDevices((prev) => devices);
  }

  // handleResize
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1536) {
        // setMapZoom(19);
        setViewport((prev) => ({ ...prev, zoom: areas[3].zoom[0] }));
      } else {
        // setMapZoom(17.3);
        setViewport((prev) => ({ ...prev, zoom: areas[3].zoom[1] }));
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // eslint-disable-line

  // Get the data for the track objs for the first time
  useLayoutEffect(() => {
    getDevices();
    if (devices.length > 0)
      setTimeout(() => {
        getHeatMapCount();
      }, 5000);
    return () => {};
    // eslint-disable-next-line
  }, []);

  // Get the up-to-date data for the track objs every 1 sec
  useInterval(
    () => {
      getHeatMapCount();
      // dispatch({ type: "UPDATE_OBJECTS", objects: rest_trackObj.length });
    },
    loading ? 1000 : 60000,
    true
  );

  const mapHeamMap = useMemo(
    () =>
      Array.from(areas).map((area) =>
        Array.from(area.devices).map((device, index) => (
          <Source
            key={device.deviceId}
            id={device.name}
            type="geojson"
            data={{
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [device.circle.lon, device.circle.lat],
              },
            }}
          >
            <Layer
              type="circle"
              paint={{
                "circle-radius": 30,
                // "heatmap-intensity-transition": { duration: 300, delay: 0 },
                // "heatmap-intensity": [
                //   "interpolate",
                //   ["linear"],
                //   ["zoom"],
                //   0,
                //   1,
                //   9,
                //   3,
                // ],
                "circle-color":
                  getDensity(heatMapCount.get(device.deviceId), maxCount) < 0.14
                    ? "#cbe394"
                    : //  "#ffffe0"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.28
                    ? "#ebe07c"
                    : // ? "#b9e5dd"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.37
                    ? "#fadd87"
                    : // ? "#5681b9"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.46
                    ? "#e8ac20"
                    : // ? "#93c4d2"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.6
                    ? "#d48019"
                    : // ? "#73a2c6"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.74
                    ? "#c24a00"
                    : // ? "#5681b9"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) <
                      0.86
                    ? "#8f0000"
                    : // ? "#3761ab"
                    getDensity(heatMapCount.get(device.deviceId), maxCount) ===
                      1
                    ? "#8f0000"
                    : // ? "#00429d"
                      "#7a7a7a",
                "circle-opacity": 0.8,
                // "circle-stroke-color": "#80A4D5",
                // "circle-stroke-width": 2,
              }}
            />
          </Source>
        ))
      ),
    // eslint-disable-next-line
    [devices, heatMapCount]
  );

  // const heatMapId = useMemo(
  //   () =>
  //     Array.from(areas).map((area) =>
  //       Array.from(area.devices).map((device, index) => (
  //         <Marker
  //           key={index}
  //           longitude={device.circle.lon}
  //           latitude={device.circle.lat}
  //           offsetTop={-8}
  //           offsetLeft={0}
  //         >
  //           <span className=" text-black opacity-90 text-lg font-bold">
  //             {/* {numberOfObjs(deviceId, rest_trackObj) > 0 ? numberOfObjs(deviceId, rest_trackObj) : ""} */}
  //             {idOfDevice(index, devices)}
  //           </span>
  //         </Marker>
  //       ))
  //     ),
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [devices]
  // );

  return (
    <div className="w-full h-full rounded-xl">
      {loading && (
        <div className="bg-gray-300 w-full h-full xl:pt-6  2xl:pt-4 rounded-md overflow-hidden transition-all">
          <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
        </div>
      )}
      <div className=" w-full h-full ">
        <ReactMapGL
          {...viewport}
          {...settings}
          attributionControl={false}
          latitude={latitude}
          longitude={longitude}
          getCursor={() => "default"}
          style={
            loading
              ? { width: "0%", height: "0%" }
              : { width: "inherit", height: "inherit" }
          }
          className={clsx(
            "rounded-xl text-xs border-4  border-white transition-all",
            { "opacity-0": loading },
            { "hidden ": loading },
            { "opacity-100": !loading }
          )}
          // style={loading ? "hidden" : "display"}
          mapStyle={MAP_STYLE}
          onViewportChange={setViewport}
          mapboxAccessToken={MAPBOX_TOKEN}
          onLoad={(e) => {
            e.target.resize();
          }}
          onRender={(e) => {
            e.target.resize();
          }}
          onResize={(e) => {
            e.target.resize();
          }}
          onData={(e) => {
            e.target.resize();
            if (e.isSourceLoaded) {
              setLoading(false);
            }
          }}
          onStyleData={(e) => {
            e.target.resize();
          }}
          // mapOptions={{ hash: true }}
        >
          {mapHeamMap}
          {/* {heatMapId} */}
        </ReactMapGL>
      </div>
    </div>
  );
};

export default StatisticMap;
